import * as Yup from 'yup';
import { Faq, Region, Activity, Tag, Program } from '../../../common/models';

export function useValidationSchema() {
  return Yup.object<Faq>().shape({
    question: Yup.string().nullable().required(),
    answer: Yup.string().nullable().required(),
    projectPhases: Yup.array<Region>().nullable().required(),
    programs: Yup.array<Program>().nullable().required(),
    activities: Yup.array<Activity>().nullable().required(),
    notices: Yup.array<Region>().nullable().required(),
    tags: Yup.array<Tag>().nullable().required(),
  });
}
